import Menu from './menu.vue';

export default Menu;
